import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import { isValidElement } from "react";
import StateSelect from "components/ui/StateSelect";
import {
  NOTISTACK_FAILURE_OPTIONS,
  NOTISTACK_SUCCESS_OPTIONS,
} from "constants/index";
import {
  useGetClientQuery,
  useUpdateClientMutation,
} from "features/trading/accounts";
import { useSnackbar } from "notistack";

export default function ClientProfile({ clientId }: { clientId?: number }) {
  const { data: client, isLoading } = useGetClientQuery(clientId, { skip: !clientId });
  const [updateClient, { isLoading: isSaving }] = useUpdateClientMutation();
  const { enqueueSnackbar } = useSnackbar();

  const handleStateChange = async (state: number | null) => {
    if (!client || state === client.state) return;
    try {
      await updateClient({ id: client.id, state }).unwrap();
      enqueueSnackbar(
        state === null ? "Client state cleared." : "Client state saved.",
        NOTISTACK_SUCCESS_OPTIONS as any,
      );
    } catch {
      enqueueSnackbar(
        "Failed to save the client's state.",
        NOTISTACK_FAILURE_OPTIONS as any,
      );
    }
  };

  const profile = client ? [
    { name: "Optic ID", value: clientId },
    { name: "Orion ID", value: clientId },
    { name: "Representative", value: client.representative__name },
    {
      name: "State",
      value: (
        // Capped so the field reads as a form control rather than a bar
        // stretched across the whole panel.
        <Box maxWidth={320}>
          <StateSelect
            value={client.state}
            onChange={handleStateChange}
            disabled={isSaving}
          />
        </Box>
      ),
    },
  ] : undefined;

  return profile ? (
    <Grid container spacing={2}>
      {profile.map((item, index) => (
        <Grid item container spacing={2} key={index} alignItems="center">
          {/* The label column is a quarter of the panel so every value lines up
              underneath the one above it. minWidth keeps the longest label
              ("Representative") from overflowing that quarter and colliding
              with its own value once the panel gets narrow. */}
          <Grid item xs={3} minWidth="fit-content">
            <Typography>{item.name}</Typography>
          </Grid>
          <Grid item xs>
            {isValidElement(item.value) ? (
              item.value
            ) : (
              <Typography>{item.value}</Typography>
            )}
          </Grid>
        </Grid>
      ))}
    </Grid>
  ) : <CircularProgress />;
}
